import { DATES, DATES_ID } from 'services/constants/dates-constants';

export const vatReimbursementStructure = [
	{
		name: 'id',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		type: 'link',
	},
	{
		name: 'EM ID',
		selector: 'emId',
		show: false,
		sortable: false,
		filterable: false,
		type: 'number',
	},
	{
		name: 'Full Name',
		selector: 'fullName',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: 'string',
		align: 'left',
	},
	{
		name: 'EM Status',
		selector: 'emStatus',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: 'boolean',
		align: 'left',
	},
	{
		name: 'Country',
		selector: 'countryCode',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: 'country',
		align: 'left',
	},

	{
		name: 'IOSS Number',
		selector: 'iossNumber',
		show: false,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: 'string',
		align: 'left',
	},
	{
		name: 'Invoice Number',
		selector: 'invoiceNumber',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: 'string',
		align: 'left',
	},
	{
		name: 'Invoice Date',
		selector: 'invoiceDate',
		show: false,
		sortable: false,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		colSpan: 1,
		type: 'date',
		align: 'left',
	},
	{
		name: 'Country Name',
		selector: 'countryName',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: 'string',
		align: 'left',
	},
	{
		name: 'Reporting Period',
		selector: 'reportingPeriod',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: 'status',
		align: 'left',
	},
	{
		name: 'IOSS reported at',
		selector: 'fiscalReportFilingDate',
		show: false,
		sortable: false,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		colSpan: 1,
		type: 'date',
		align: 'left',
	},
	{
		name: 'Amount',
		selector: 'reimbursementAmount',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: 'currency',
		align: 'right',
	},
	{
		name: 'Status',
		selector: 'paymentStatus',
		show: true,
		sortable: false,
		filterable: true,
		filter: [
			['paid', 'Paid'],
			['pending', 'Pending'],
		],
		colors: [
			['paid', 'success.light'],
			['pending', 'warning.light'],
		],
		colSpan: 1,
		type: 'status',
		align: 'left',
	},
	{
		name: 'Money received',
		selector: 'moneyReceived',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: 'boolean',
		align: 'left',
	},
	{
		name: 'Money received at',
		selector: 'receivedAt',
		show: false,
		sortable: false,
		filterable: true,
		filter: [
			['empty', 'Empty date'],
			['notEmpty', 'Not empty date'],
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		colSpan: 1,
		type: 'date',
		align: 'left',
	},
	{
		name: 'Included into Invoice',
		selector: 'invoicedBy',
		show: false,
		sortable: false,
		filterable: true,
		filter: [
			['empty', 'Empty'],
			['notEmpty', 'Not empty'],
		],
		colSpan: 1,
		type: 'string',
		align: 'left',
	},

	{
		name: 'Comments',
		selector: 'comments',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: 'text',
		align: 'left',
	},
	{
		name: 'Edited by',
		selector: 'editedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: 'user',
		align: 'left',
	},
	{
		name: 'Actions',
		selector: 'actions',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: 'buttons',
		align: 'left',
		buttons: [{ name: 'Receive' }, { name: 'Add Comment' }],
	},
];
